const currentDate = new Date().toISOString().slice(0, 10)

/**
 * Function for determining if a user has a platinum subscription.
 * @param {object} user - the current User
 *
 * @returns {boolean} if the user has a platinum subscription
 */
export const isPlatinum = user =>
  user &&
  (user.platinum ||
    !!user.subscriptions.filter(
      ({ subscriptionPlan, awaitingCompletion, serviceableUntil, status }) =>
        !awaitingCompletion &&
        (serviceableUntil >= currentDate || status === 'Active') &&
        subscriptionPlan &&
        subscriptionPlan.type === 'SubscriptionPlan::Platinum',
    ).length)
